
import { defineComponent } from "vue";
import PlusButton from "./PlusButton.vue";

export default defineComponent({
  components: { PlusButton },
  props: {
    text: {
      type: [Number, String],
      required: false,
      default: 0,
    },
    icon: {
      type: String,
      required: true,
    },
    nobackground: {
      type: Boolean,
      required: false,
      default: false,
    },
    plusSign: {
      type: Boolean,
      required: false,
      default: false,
    },
    outline: {
      type: Boolean,
      required: false,
      default: false,
    },
    alignRight: {
      type: Boolean,
      required: false,
      default: true,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    red: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["image-clicked"],
  methods: {
    imageClicked(): void {
      this.$emit("image-clicked");
    },
  },
});
